<app-full-screen-loader *ngIf="preventAbuse" />
<p-sidebar
  [(visible)]="sideChat"
  styleClass="aiChatSidebar"
  [dismissible]="false"
  [closeOnEscape]="false"
  [fullScreen]="true"
>
  <ng-template pTemplate="header"></ng-template>
  <ng-template pTemplate="content">
    <div class="aiChatModalBlock" style="height: 100%">
      <!--<div class="askWrapper d-none">
        <app-ai-ask />
      </div>-->
      <div class="chatBlock">
        <!--<app-ai-chat-history [currentWorkspace]="activeWorkspace" />-->
        <div class="wrapChatBox">
          <app-ai-live-chat [currentWorkspace]="activeWorkspace" />
        </div>
      </div>
    </div>
  </ng-template>
  <!-- <ng-template pTemplate="footer">Footer Content</ng-template> -->
</p-sidebar>
<header #header id="main-header" class="header">
  <div *ngIf="selectedWorkspace" class="container-fluid">
    <nav class="navbar navbar-expand navbar-light">
      <p-button
        class="d-lg-none"
        data-toggle="collapse"
        data-target="#mobileNav"
        aria-expanded="false"
        aria-controls="mobileNav"
        styleClass="sidemenuToggleBtn"
        icon="pi pi-bars"
      ></p-button>
      <a class="navbar-brand" [routerLink]="'/'">
        <img width="150px" class="lightLogo" src="assets/images/logo/confe-light-web.svg" alt="" />
        <!-- <img width="150px" class="darkLogo" src="assets/images/logo/confe-dark-web.svg" alt="" />-->
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#mobileNav"
        aria-expanded="false"
        aria-controls="mobileNav"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarColor03">
        <div class="workspaceDropdown">
          <div class="d-flex justify-content-center">
            <p-dropdown
              styleClass=""
              [options]="workspaces"
              [(ngModel)]="selectedWorkspace"
              optionLabel="name"
              [showClear]="false"
              placeholder="Select Workspace"
              (onChange)="changeWorkspace($event)"
            >
              <ng-template pTemplate="header">
                <div class="dropdownHeader">
                  <p-button
                    (click)="createNewWorkspace()"
                    label="Create new workspace"
                    icon="pi pi-plus-circle"
                    styleClass="newCompany"
                  />
                </div>
              </ng-template>

              <ng-template pTemplate="selectedItem">
                <div class="d-flex align-items-center" *ngIf="selectedWorkspace">
                  <!--  <img class="workIcon" src="assets/images/html/techbrand.png" />-->
                  <!--<p-avatar
                    styleClass="workIcon"
                    [style]="{
                      'background-color': '#' + selectedWorkspace.hex_color,
                      color: '#ffffff',
                    }"
                    [label]="selectedWorkspace.name.charAt(0).toUpperCase()"
                    shape="circle"
                  ></p-avatar>-->

                  <div
                    [style]="{
                      'background-color': '#' + selectedWorkspace.hex_color,
                      color: '#ffffff',
                      padding: '10px',
                      borderRadius: '50%',
                    }"
                    class="workIcon avatar text-white"
                  >
                    {{ selectedWorkspace.name.charAt(0).toUpperCase() }}
                  </div>

                  <div>
                    {{ selectedWorkspace.name }}
                    <div *ngIf="!selectedWorkspace.planInfo.trialInfo.isInTrial">
                      <span
                        class="trial smallTxt"
                        *ngIf="!selectedWorkspace.planInfo.subscriptionInfo.subscription"
                        style="color: red"
                        >No active plan</span
                      >
                    </div>
                    <div *ngIf="selectedWorkspace.planInfo.trialInfo.isInTrial">
                      <span
                        class="trial smallTxt"
                        *ngIf="
                          !selectedWorkspace.planInfo.trialInfo.has_expired_trial &&
                          !selectedWorkspace.planInfo.trialInfo.isLifetimeFreeTrial
                        "
                        style="color: orange"
                        >(In Trial)</span
                      >
                      <span
                        class="expired smallTxt"
                        *ngIf="selectedWorkspace.planInfo.trialInfo.has_expired_trial"
                        style="color: red"
                        >(Trial expired)</span
                      >
                      <span
                        class="free smallTxt"
                        *ngIf="selectedWorkspace.planInfo.trialInfo.isLifetimeFreeTrial"
                        style="color: green"
                        >(Always on free Trial)</span
                      >
                    </div>
                  </div>
                </div>
              </ng-template>

              <ng-template let-workspace pTemplate="item">
                <div
                  *ngIf="!workspace.isWpSetting"
                  class="d-flex align-items-center text-wrap listItem"
                >
                  <p-avatar
                    styleClass="workIcon"
                    [style]="{ 'background-color': '#' + workspace.hex_color, color: '#ffffff' }"
                    [label]="workspace.name.charAt(0).toUpperCase()"
                    shape="circle"
                  ></p-avatar>

                  <div>
                    {{ workspace.name }}
                    <div *ngIf="!workspace.planInfo.trialInfo.isInTrial">
                      <span
                        class="trial smallTxt"
                        *ngIf="!workspace.planInfo.subscriptionInfo.subscription"
                        style="color: red"
                        >No active plan</span
                      >
                    </div>

                    <div *ngIf="workspace.planInfo.trialInfo.isInTrial">
                      <span
                        class="trial smallTxt"
                        *ngIf="
                          !workspace.planInfo.trialInfo.has_expired_trial &&
                          !workspace.planInfo.trialInfo.isLifetimeFreeTrial
                        "
                        style="color: orange"
                        >(In Trial)</span
                      >
                      <span
                        class="expired smallTxt"
                        *ngIf="workspace.planInfo.trialInfo.has_expired_trial"
                        style="color: red"
                        >(Trial expired)</span
                      >
                      <span
                        class="free smallTxt"
                        *ngIf="workspace.planInfo.trialInfo.isLifetimeFreeTrial"
                        style="color: green"
                        >(Always on free Trial)</span
                      >
                    </div>
                  </div>
                </div>
                <!--<div *ngIf="workspace.isWpSetting" class="d-flex align-items-center listItem">
                  <img class="workIcon" src="/assets/images/menu/setting.svg" />
                  <div>{{ workspace.name }}</div>
                </div>-->
              </ng-template>

              <!-- <ng-template pTemplate="footer">
                <div class="p-2 d-flex justify-between">
                  <p-button
                    [routerLink]="'/workspace/settings'"
                    label="Manage"
                    severity="secondary"
                    [link]="true"
                    size="small"
                    icon="pi pi-cog"
                    styleClass="shadow-none"
                  />
                  <p-button
                    label="Create"
                    severity="help"
                    [link]="true"
                    size="small"
                    icon="pi pi-plus"
                    styleClass="shadow-none"
                  />
                </div>
              </ng-template> -->
            </p-dropdown>

            <div
              id="workspace-settings"
              routerLink="/workspace/settings"
              pTooltip="Workspace Settings"
              tooltipPosition="top"
              class="settingBtnIcon"
            >
              <i class="pi pi-cog"></i>
            </div>
          </div>
        </div>

        <ul class="navbar-nav btns">
          <li class="nav-item">
            <div *ngIf="selectedWorkspace.planInfo.trialInfo.isInTrial">
              <p-message
                *ngIf="
                  selectedWorkspace.planInfo?.trialInfo.remaining_trial_days >= 0 &&
                  !selectedWorkspace.planInfo?.trialInfo.has_expired_trial
                "
                styleClass="trialExpBtn"
                severity="warn"
                text="{{
                  selectedWorkspace.planInfo?.trialInfo.remaining_trial_days
                }} days left in your free trial"
              >
              </p-message>

              <p-message
                *ngIf="
                  selectedWorkspace.planInfo?.trialInfo.remaining_trial_days == 0 &&
                  selectedWorkspace.planInfo?.trialInfo.has_expired_trial
                "
                styleClass="trialExpBtn"
                severity="warn"
                text="Your free trial has ended"
              >
              </p-message>
            </div>
            <!--for New Workspace no Plan-->
            <p-message
              *ngIf="
                !selectedWorkspace.planInfo.trialInfo.isInTrial &&
                !selectedWorkspace.planInfo?.subscriptionInfo.subscription
              "
              styleClass="trialExpBtn"
              severity="error"
              text="You haven’t subscribed to a plan yet"
            >
            </p-message>
            <!--for Plan Expired message-->
            <p-message
              *ngIf="
                !selectedWorkspace.planInfo.trialInfo.isInTrial &&
                selectedWorkspace.planInfo?.subscriptionInfo.subscription &&
                !isPaidSubscriptionActive()
              "
              styleClass="trialExpBtn"
              severity="warn"
              text="Your subscription is expired"
            >
            </p-message>
          </li>

          <li class="nav-item">
            <a
              *ngIf="
                selectedWorkspace.planInfo?.trialInfo.isInTrial ||
                selectedWorkspace.planInfo.trialInfo.has_expired_trial ||
                !selectedWorkspace.planInfo.subscriptionInfo.subscription
              "
              class="upgradeNowBtn"
              routerLink="/plans"
            >
              <img src="/assets/images/dashboard/upgrade.svg" alt="" />
              Upgrade Now
            </a>
            <a
              *ngIf="
                selectedWorkspace.planInfo.subscriptionInfo?.subscription?.name &&
                !isPaidSubscriptionActive()
              "
              class="upgradeNowBtn"
              routerLink="/plans"
            >
              <img src="/assets/images/dashboard/upgrade.svg" alt="" />
              Renew Now
            </a>
          </li>
          <!-- <li class="nav-item">
            <a (click)="sideChat = true" class="upgradeNowBtn">
              <img src="/assets/images/dashboard/ai-chat.svg" alt="" />
              AI Chat
            </a>
          </li>-->
        </ul>
        <ul class="navbar-nav">
          <!--<li class="nav-item active">
            <a class="nav-link" href="#"><img src="assets/images/logo/search.svg" alt="" /></a>
          </li>-->
          <!--<li class="nav-item" (click)="switchTheme($event)">
            <a href="#" onclick="return false;" class="nav-link">
              <img class="moon" src="assets/images/logo/moon.svg" alt="" />
              <img class="sun" src="assets/images/logo/sun.svg" alt="" />
            </a>
          </li>-->

          <!--<li class="nav-item">
            <a class="nav-link">
              <img src="/assets/images/dashboard/post-notify.svg" width="32" alt="" />
            </a>
          </li>-->
          <li
            (click)="openChangeLog()"
            pTooltip="What's new"
            tooltipPosition="top"
            class="nav-item"
          >
            <a class="nav-link">
              <div class="whats-new-container">
                <img src="/assets/images/dashboard/whats-new.svg" width="32" alt="" />
                <span *ngIf="hasUnreadChangelog" class="unread-dot"></span>
              </div>
            </a>
          </li>
          <li pTooltip="Help & Support" tooltipPosition="top" class="nav-item">
            <a (click)="helpMenu.toggle($event)" class="nav-link" style="cursor: pointer">
              <i class="pi pi-question-circle" style="font-size: 1.4rem"></i>
            </a>
            <p-menu #helpMenu [model]="helpMenuItems" [popup]="true"></p-menu>
          </li>
          <li pTooltip="Notifications" tooltipPosition="top" class="nav-item">
            <app-notification-panel />
          </li>
        </ul>
      </div>
      <div class="userInfo">
        <!-- <div class="text">
          <p class="welcome">Good Morning</p>
          <p class="userName">Hi {{ userData && userData.name }}</p>
        </div> -->
        <div class="userSelection">
          <a
            class="d-flex align-items-center"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <p-avatar
              styleClass="workIcon primary image"
              [label]="userData.name.charAt(0).toUpperCase()"
              shape="circle"
            ></p-avatar>
            <img class="arrowDown ml-2" src="assets/images/html/arrow-down.svg" alt="" />
          </a>

          <div class="dropdown-menu">
            <div class="details">
              <p-avatar
                styleClass="workIcon primary image"
                [label]="userData.name.charAt(0).toUpperCase()"
                shape="circle"
              ></p-avatar>
              <div class="userId">
                <p class="userName">{{ userData && userData.name }}</p>
                <p class="mail">{{ userData && userData.email }}</p>
              </div>
            </div>
            <div class="dropdownHeader">
              <p-button
                (click)="createNewWorkspace()"
                label="Create new workspace"
                icon="pi pi-plus-circle"
                styleClass="newCompany"
              />
            </div>
            <div class="linkList">
              <!--<div class="linkItem">
                <div class="ico">
                  <img src="/assets/images/menu/profile.svg" alt="" />
                </div>
                <a href="#">Profile</a>
              </div>-->
              <div [routerLink]="['/account-setting']" class="linkItem">
                <div class="ico">
                  <img src="/assets/images/menu/account.svg" alt="" />
                </div>
                <a>Account Settings</a>
              </div>
              <div [routerLink]="['/workspace/settings']" class="linkItem">
                <div class="ico">
                  <img src="/assets/images/menu/setting.svg" alt="" />
                </div>
                <a>Workspace Settings</a>
              </div>
              <div
                [routerLink]="['/account-setting']"
                [queryParams]="{ selectedTab: 'change-password' }"
                class="linkItem"
              >
                <div class="ico">
                  <img src="/assets/images/menu/password.svg" alt="" />
                </div>
                <a>Change Password</a>
              </div>
            </div>
            <div class="dropdown-divider"></div>
            <div class="upgrade">
              <div>
                <span class="title">AI credits</span>
                <!--<span class="days">27 Days left</span>-->
              </div>
              <div>
                <span pTooltip="AI credits left" tooltipPosition="top" class="upgrade">{{
                  activeWorkspace?.limits?.AICredits || 0
                }}</span>
              </div>
            </div>
            <div class="upgrade" *ngIf="activeWorkspace?.limits?.AIImageCredits != null">
              <div>
                <span class="title">AI Image credits</span>
              </div>
              <div>
                <span pTooltip="AI Image credits left" tooltipPosition="top" class="upgrade">{{
                  activeWorkspace?.limits?.AIImageCredits || 0
                }}</span>
              </div>
            </div>
            <div class="dropdown-divider"></div>
            <div class="linkList pb-2" (click)="logout()">
              <div class="linkItem">
                <div class="ico">
                  <img src="/assets/images/menu/logout.svg" alt="" />
                </div>
                <a (click)="logout()">Logout</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</header>
<ng-progress [style.top]="progressBarTop" />
